import script from "./ImagethumbnailDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagethumbnailDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ImagethumbnailDisplay.vue?vue&type=style&index=0&id=3a510ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a510ada"]])

export default __exports__